import React, { useState } from "react";
import { Row, Fade } from "react-bootstrap";
import { useEffect } from "react";
import { Group, ColWrapper, HeadingWrapper } from "./tree/Heading";
import { MenuLink } from "./tree/MenuLink";
import { useSelector } from "react-redux";
import { i18n } from "app/i18n/i18n";

export const DesktopMenu = ({ path }) => {
  const menuItems = useSelector((state) => state.menu.items);
  const [fadeIn, setFadeIn] = useState(false);
  const lang = i18n.getLanguage();
  const items = menuItems[lang].filter((i) => i.menu === path)[0].children;
  useEffect(() => {
    setFadeIn(true);
  }, [setFadeIn]);

  return (
    <Fade in={fadeIn} fade={1000}>
      <Row className="text-nowrap px-3">{items.map(renderDesktop)}</Row>
    </Fade>
  );
};

export const renderDesktop = (item, key) => {
  if (isExcluded(item)) return null;
  else if (item.heading) return <HeadingWrapper key={key} {...item} />;
  else if (item.group) return <Group key={key} {...item} />;
  else if (item.link) return <MenuLink key={key} {...item} />;
  else if (item.col) return <ColWrapper key={key} {...item} />;
  else if (item.separator) return <p key={key} />;
  return null;
};

const isExcluded = (item) => item.title || item.mobileOnly || item.node === "Settings";
